import { Component } from '@angular/core';
import { HeaderComponent } from '../header-component/header-component';
import { SidebarComponent } from '../sidebar-component/sidebar-component';
import { RouterModule } from '@angular/router';
import { CommonService } from '../../core/services/common.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-main-layout',
  imports: [HeaderComponent, SidebarComponent, RouterModule,CommonModule],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss'
})
export class MainLayout {


    toggleSideBar: boolean = true;
    private toggleBarSubscription = new Subscription()
  
    constructor(private _commonService: CommonService) {
  
    }
  
    ngOnInit() {
      this.toggleBarSubscription = this._commonService.$sidebarToggle.subscribe((value: boolean) => {
        this.toggleSideBar = value
      })
    }
  
  
    ngOnDestroy() {
      if (this.toggleBarSubscription) {
        this.toggleBarSubscription.unsubscribe();
      }
    }

}
